import { createAction, createSlice } from '@reduxjs/toolkit';
import { ClientMessagesStatusEnum, ClientMessagesTypeEnum } from '@tassat/common-definitions';
import { ClientMessageRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export type ClientMessageRecordMap = {
    [id: string]: ClientMessageRecord;
};

export interface ClientMessageState {
    client: {
        banner: ClientMessageRecord;
        advisory: ClientMessageRecord;
    };
    admin: {
        history: ClientMessageRecordMap;
        validation: ClientMessageRecordMap;
    };
}

const initialState: ClientMessageState = {
    client: {
        banner: null as unknown as ClientMessageRecord,
        advisory: null as unknown as ClientMessageRecord
    },
    admin: {
        history: {},
        validation: {}
    }
};

const initialLoadAction = createAction<{ clientMessages: ClientMessageRecordMap }>('InitialLoad');
const setClientMessagesAction = createAction<ClientMessageRecord[]>('SET_CLIENT_MESSAGES');
const clientMessageRecordAction = createAction<ClientMessageRecord>(CoreMsgTypes.ClientMessageRecord);

const clientMessageSlice = createSlice({
    name: 'clientMessage',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                Object.assign(state.admin.validation, action.payload.clientMessages);
            })
            .addCase(setClientMessagesAction, (state, action) => {
                state.admin.history = {};
                action.payload.forEach((message) => {
                    state.admin.history[message.MessageId] = message;
                });
            })
            .addCase(clientMessageRecordAction, (state, action) => {
                if (action.payload.ClientMsgType === ClientMessagesTypeEnum.BANNER &&
                    action.payload.Status === ClientMessagesStatusEnum.DISPLAYABLE) {
                    state.client.banner = action.payload;
                }
                if (action.payload.ClientMsgType === ClientMessagesTypeEnum.ADVISORY &&
                    action.payload.Status === ClientMessagesStatusEnum.DISPLAYABLE) {
                    state.client.advisory = action.payload;
                }
                state.admin.history[action.payload.MessageId] = action.payload;
                state.admin.validation[action.payload.MessageId] = action.payload;
            });
    }
});

export default clientMessageSlice.reducer;